import {formatDate, formatDocumentOrganizationUnit} from 'utils/valueFormatter.function';
import {leaveRequestDocumentDetailsProps} from "types/documentDetailsDTO";
import {Tooltip} from "components/tooltip/Tooltip";

const LeaveRequestDocumentDetailsDTO = ({details, translate}: leaveRequestDocumentDetailsProps) => {
    let displayId = details.displayId ? details.displayId : details.documentId;
    return (
        <div>
            {details.description &&
                <div className="document-data-field">
                    <div className="document-data-field-label">
                        {translate("documentData.description")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="description-value-tooltip">
                        {details.description}
                        <Tooltip id="description-value-tooltip" content={() => details.description}/>
                    </div>
                </div>}

            <div className="document-data-divided">

                {details.userName &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.requester")}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="" data-for="requester-value-tooltip">
                            {details.userName}
                            <Tooltip id="requester-value-tooltip" content={() => details.userName}/>
                        </div>
                    </div>}

                {details.employeeCode &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.employeeCode")}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="" data-for="employeeCode-value-tooltip">
                            {details.employeeCode}
                            <Tooltip id="employeeCode-value-tooltip" content={() => details.employeeCode}/>
                        </div>
                    </div>}

                <div className="document-data-field third">
                    <div className="document-data-field-label">
                        {translate("documentData.documentID")}
                    </div>
                    <div className="document-data-field-value"
                         data-tip="" data-for="documentID-value-tooltip">
                        {displayId}
                        <Tooltip id="documentID-value-tooltip" content={() => displayId}/>
                    </div>
                </div>

                {details.documentOrganizationUnit &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.organizationUnit")}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="" data-for="organizationUnit-value-tooltip">
                            {formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                            <Tooltip id="organizationUnit-value-tooltip" content={() => formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>
                        </div>
                    </div>}

                {details.receivedDate > 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label ast_receivedDate">
                            {translate("documentData.receivedDate")}
                        </div>
                        <div className="document-data-field-value ast_receivedDate_value">
                            {formatDate(details.receivedDate, null)}
                        </div>
                    </div>}

                {details.dueDate > 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label ast_dueDate">
                            {translate("documentData.dueDate")}
                        </div>
                        <div className="document-data-field-value ast_dueDate_value">
                            {formatDate(details.dueDate, null)}
                        </div>
                    </div>}

                {details.fromDate > 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.fromDate")}
                        </div>
                        <div className="document-data-field-value ast_fromDate_value">
                            {formatDate(details.fromDate, null)}
                        </div>
                    </div>}

                {details.toDate > 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.toDate")}
                        </div>
                        <div className="document-data-field-value ast_toDate_value">
                            {formatDate(details.toDate, null)}
                        </div>
                    </div>}

                {details.eventCode &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label">
                            {translate("documentData.eventCode")}
                        </div>
                        <div className="document-data-field-value"
                             data-tip="" data-for="eventCode-value-tooltip">
                            {details.eventCode}
                            <Tooltip id="eventCode-value-tooltip" content={() => details.eventCode}/>
                        </div>
                    </div>}

                {details.numberOfDays >= 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label ast_numberOfDays">
                            {translate("documentData.numberOfDays")}
                        </div>
                        <div className="document-data-field-value">
                            {details.numberOfDays}
                        </div>
                    </div>}

                {details.numberOfHours >= 0 &&
                    <div className="document-data-field third">
                        <div className="document-data-field-label ast_numberOfHours">
                            {translate("documentData.numberOfHours")}
                        </div>
                        <div className="document-data-field-value">
                            {details.numberOfHours}
                        </div>
                    </div>}

            </div>
        </div>
    )
};

export default LeaveRequestDocumentDetailsDTO;
